import React from 'react';
export var ErrorFallback = function (_a) {
    var error = _a.error;
    return React.createElement(React.Fragment, null);
};
